<mat-checkbox
  color="primary"
  [appTheme]="'THEME_SYSTEM_SUCCESS'"
  [formControl]="formControl">
  <ng-content></ng-content>
</mat-checkbox>
